import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, WritableSignal, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IstatComuniInputSelectComponent } from 'src/app/modules/istat-comuni/components/istat-comuni-input-select/istat-comuni-input-select.component';
import { IstatRegioniInputSelectComponent } from 'src/app/modules/istat-regioni/components/istat-regioni-input-select/istat-regioni-input-select.component';
import { PuntiCampionamentoTipologieInputSelectComponent } from 'src/app/modules/punti-campionamento-tipologie/components/punti-campionamento-tipologie-input-select/punti-campionamento-tipologie-input-select.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';

@Component({
  selector: 'app-uuid-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IstatRegioniInputSelectComponent,
    IstatComuniInputSelectComponent,
    PuntiCampionamentoTipologieInputSelectComponent,
    InputTextComponent
  ],
  templateUrl: './uuid-form.component.html',
  styleUrl: './uuid-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UuidFormComponent {
  @Input() form!: FormGroup;

  istatRegione: WritableSignal<number | undefined> = signal(undefined);

  ngOnInit() {
    this.form.addControl('uuid', new FormControl('', [Validators.required]));
    this.form.addControl('istatComune', new FormControl('', [Validators.required]));
    this.form.addControl('istatRegione', new FormControl('', [Validators.required]));
    this.form.addControl('tipoPuntoCampionamento', new FormControl('', [Validators.required]));
    this.form.addControl('idPuntoCampionamento', new FormControl('', [Validators.required]));

    this.form.get('istatRegione')?.valueChanges.subscribe(() => {
      this.updateUUID();
      this.filterComuni();
    });
    this.form.get('istatComune')?.valueChanges.subscribe(() => {
      this.updateUUID();
    });
    this.form.get('tipoPuntoCampionamento')?.valueChanges.subscribe(() => {
      this.updateUUID();
    });
    this.form.get('idPuntoCampionamento')?.valueChanges.subscribe(() => {
      this.updateUUID();
    });
  }

  updateUUID() {
    // Esegui il calcolo del nuovo valore per uuid
    const nuovoUUID = this.calcolaNuovoUUID();

    // Imposta il nuovo valore di uuid nel form
    this.form.patchValue({ uuid: nuovoUUID });
  }

  filterComuni() {
    this.istatRegione.set(this.form.get('istatRegione')?.value);
  }

  calcolaNuovoUUID(): string {
    // Logica per il calcolo del nuovo valore di uuid basato sui valori di istatComune, istatRegione e codiceAcquedotto
    const istatRegione = this.form.get('istatRegione')?.value;
    const istatComune = this.form.get('istatComune')?.value;
    const tipoPuntoCampionamento = this.form.get('tipoPuntoCampionamento')?.value;
    const idPuntoCampionamento = this.form.get('idPuntoCampionamento')?.value;
    // Esempio di logica di calcolo, puoi personalizzare secondo le tue esigenze
    const nuovoUUID = `${istatRegione}_${istatComune}_${tipoPuntoCampionamento}_${idPuntoCampionamento}`;

    return nuovoUUID;
  }
}
